module.exports = __webpack_public_path__ + "static/img/man.3be064ae.jpg";